<template>
  <div>
    <v-btn :color="color" small v-show="show" @click="update">{{text}}</v-btn>
  </div>
</template>

<script>
import Mustache from 'mustache'
import {EventMixin} from '@/lib/mixins.js';
export default {
  mixins: [EventMixin],
  props: ['text', 'from', 'to', 'color'],
  computed: {
    val: {
      get () {
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  },
  methods: {
    update() {
      var text = Mustache.render(this.from, this.value);
      var value = _.cloneDeep(this.value);
      var val = _.get(this.value, this.to.field);
      if(this.to.type == "multilanguage") {
        val.forEach((item) => {
          item.value = text;
        });
      } else if(this.to.type == "text") {
        val = text;
      }
      _.set(value, this.to.field, val);
      this.$emit("input", value);
    }
  }
}

</script>
